export default () => (
  <table className="listTable listTable--mock">
    <tbody>
      <tr><td className="listTable_mock" colSpan="200" /></tr>
      <tr><td className="listTable_mock" colSpan="200" /></tr>
      <tr><td className="listTable_mock" colSpan="200" /></tr>
    </tbody>
  </table>
);
